var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "order-allocation-details" },
    [
      _c(
        "basic-container",
        [
          _c("OrderSearch", {
            attrs: {
              searchForm: _vm.searchForm,
              loadingExporth: _vm.loadingExporth,
              businessTypeOptions: _vm.businessTypeOptions,
              paymentMethodOptions: _vm.paymentMethodOptions,
              purchaseSourceOptions: _vm.purchaseSourceOptions,
              clientTypesOptions: _vm.clientTypesOptions,
              memberTypeOptions: _vm.memberTypeOptions,
              goodsNameOptions: _vm.goodsNameOptions,
            },
            on: {
              search: _vm.handleSearch,
              export: _vm.exportList,
              rerun: _vm.openRerunDialog,
              viewHistory: _vm.openHistoryDialog,
            },
          }),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c("OrderTable", {
                attrs: { tableData: _vm.tableData, loading: _vm.loading },
              }),
              _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("ElementPagination", {
                    attrs: {
                      "current-page": _vm.page.current,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.page.size,
                      total: _vm.page.total,
                      layout: "total, sizes, prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "重跑收入/成本确认数据",
            visible: _vm.rerunDialogVisible,
            width: "500px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rerunDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "rerunForm",
              attrs: {
                model: _vm.rerunForm,
                rules: _vm.rerunRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "开始月份", prop: "startMonth" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "month",
                      placeholder: "请选择开始月份",
                      format: "yyyyMM",
                      "value-format": "yyyyMM",
                    },
                    model: {
                      value: _vm.rerunForm.startMonth,
                      callback: function ($$v) {
                        _vm.$set(_vm.rerunForm, "startMonth", $$v)
                      },
                      expression: "rerunForm.startMonth",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "结束月份", prop: "endMonth" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "month",
                      placeholder: "请选择结束月份",
                      format: "yyyyMM",
                      "value-format": "yyyyMM",
                    },
                    model: {
                      value: _vm.rerunForm.endMonth,
                      callback: function ($$v) {
                        _vm.$set(_vm.rerunForm, "endMonth", $$v)
                      },
                      expression: "rerunForm.endMonth",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单ID" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "可选，填写则只重跑该订单",
                      clearable: "",
                    },
                    model: {
                      value: _vm.rerunForm.orderId,
                      callback: function ($$v) {
                        _vm.$set(_vm.rerunForm, "orderId", $$v)
                      },
                      expression: "rerunForm.orderId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rerunDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.rerunLoading },
                  on: { click: _vm.submitRerun },
                },
                [_vm._v("确认重跑")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "重跑历史记录",
            visible: _vm.historyDialogVisible,
            width: "800px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.historyDialogVisible = $event
            },
            opened: _vm.loadHistory,
            close: _vm.handleHistoryClose,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "text",
                    icon: "el-icon-refresh",
                    loading: _vm.historyLoading,
                  },
                  on: { click: _vm.loadHistory },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.historyLoading,
                  expression: "historyLoading",
                },
              ],
              attrs: { data: _vm.historyList, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "month", label: "月份", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "requestTime", label: "触发时间", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusTagType(row.status),
                              size: "small",
                            },
                          },
                          [_vm._v(_vm._s(row.status))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "finishTime", label: "结束时间", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.finishTime || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "orderId", label: "订单ID", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.orderId || "全量统计") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "errorMsg",
                  label: "错误信息",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.errorMsg
                          ? _c("span", { staticStyle: { color: "#f56c6c" } }, [
                              _vm._v(_vm._s(row.errorMsg)),
                            ])
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }